export * from './IconQuestionBubbleGradient';
export { default as IconQuestionBubbleGradient } from './IconQuestionBubbleGradient';
